'use client';

/**
 * `useWithdrawGift` — delegates to the host's implementation.
 * See `./host-context.tsx` for the rationale.
 */
import { useGiftingHostContext } from './host-context.js';
export function useWithdrawGift() {
  const {
    useWithdrawGift: impl
  } = useGiftingHostContext();
  return impl();
}